import React, { useEffect } from "react"
import styled from "styled-components"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { colors, H1White, standardWrapper } from "../../../styles/helpers"

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

const CommonBites = ({ data }) => {
  useEffect(() => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: "#bite-trigger",
          markers: false,
          start: "top 40%",
          toggleActions: "play none none none",
        },
      })
      .to(".bite-item", {
        rotation: 360,
        duration: 1,
        stagger: {
          each: 0.25,
        },
      })
  }, [])

  return (
    <SectionStyled>
      <div className="wrapper">
        <div className="title">
          <h2>Common bite problems</h2>
        </div>
        <div id="bite-trigger" className="bites">
          {data.bites.map((bite, index) => {
            const iconDisplay = getImage(
              bite.image.localFile.childImageSharp.gatsbyImageData
            )
            const iconAlt = bite.image.altText

            return (
              <BiteImage className="bite-item" key={index}>
                <GatsbyImage
                  image={iconDisplay}
                  alt={iconAlt}
                  layout="fullWidth"
                  formats={["auto", "webp", "avif"]}
                />
              </BiteImage>
            )
          })}
        </div>
      </div>
    </SectionStyled>
  )
}

const SectionStyled = styled.section`
  padding: 12.5rem 0;
  background-color: rgba(217, 201, 158, 0.6);

  .wrapper {
    ${standardWrapper};
  }

  .title {
    width: 100%;
    text-align: center;

    h2 {
      ${H1White};
      display: inline-block;
      padding: 0 2rem;
      background-color: ${colors.colorPrimary};
    }
  }

  .bites {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    padding-top: 4rem;
  }
`

const BiteImage = styled.div`
  width: calc(100% / 2);
  margin: 3rem auto;
  padding: 1rem;

  @media (min-width: 768px) {
    width: calc(100% / 3);
    margin: auto;
    padding: 2rem;
  }
`

export default CommonBites
